// jQuery and plugins
// jQuery is in webpack config as external, should be loaded manually in head from CDN
import 'jquery'
import 'jquery-match-height'
import 'smartmenus'
import 'slick-carousel'

// Styles
// Requires preserve order whereas imports are hoisted to the top of the output
require('normalize.css');
require('smartmenus/dist/css/sm-core-css.css');
require('slick-carousel/slick/slick.css');
require('slick-carousel/slick/slick-theme.css');
require('./sass/style.scss');
require('./sass/loic.scss');


// Code that relies on document ready.
$(document).ready(function () {

    // Initialise smart menus
    $('#main-menu').smartmenus();

    // Initialise match-height
    $('.match-height').matchHeight();
    $('.match-height-title').matchHeight();
    $('.match-height-button').matchHeight();

    // Run the EDD customisations
    edd_customisations();

    // Run the following functions when facetwp is loaded/refreshed
    $(document).on('facetwp-loaded', edd_customisations );

    // Initialise the jquery-ui tabs on the single download page
    $('#tabs').tabs();

    // helper for account menu (memberpress)
    $(".my-account-mobile-toggle").on('click', function(event) {
        $(".mk-account-nav").toggleClass('expanded');
    });

    $('.show-search').click(function() {
        console.log('clicked');
        document.getElementById("search-bar").style.height = "100%";
        document.getElementById("search-input").focus();
    });

    $('#hide-search').click(function() {
        document.getElementById("search-bar").style.height = "0%";
    });

    $(".sidebar-title").on('click', function(event) {
        $(this).toggleClass('active');
        $(".shop-sidebar .filter-search").toggleClass('active');
        $(".shop-sidebar .filter-categories").toggleClass('active');
        $(".shop-sidebar .filter-tags").toggleClass('active');
    });


    $('.free-trial-link').click(function (e) {
    	e.preventDefault();
        $('.free-trial-form input[name="mka_trial_signup_user"]').focus();
    });
});

function edd_customisations() {

    $(document).ready(function () {

        // On facet filter/pagination - scroll back to the top of the page
        $(window).scrollTop(0);

        // Iterate over each element and replace the tag while maintaining attributes
        $('form .edd_price_options ul').each(function() {

            // Create a new element and assign it attributes from the current element
            var NewElement = $("<select />");
            $.each(this.attributes, function(i, attrib){
                $(NewElement).prop(attrib.name, attrib.value);
            });

            // Replace the current element with the new one and carry over the contents
            $(this).replaceWith(function () {
                return $(NewElement).append($(this).contents());
            });

        });

        // Iterate over each element and replace the tag while maintaining attributes
        $('form .edd_price_options li').each(function() {

            // Create a new element and assign it attributes from the current element
            var NewElement = $("<option />");
            $.each(this.attributes, function(i, attrib){
                $(NewElement).prop(attrib.name, attrib.value);
            });

            // Replace the current element with the new one and carry over the contents
            $(this).replaceWith(function () {
                return $(NewElement).append($(this).contents());
            });

        });

        // Update the radio price for variable price products on dropdown select
        $('form .edd_price_options select').each(function() {
            var $this = $(this);

            $($this).change(function() {
                var $input = $this.find("option:selected input");
                $($input).prop('checked', 'checked');
            });

        });

        // Change the shop cart labels text - removes the price from within the button
        $('.edd-add-to-cart-label').each(function() {
            $(this).text('Add to cart');
        });

        // Manually fire off a match height update
        $.fn.matchHeight._update();
        $('.match-height-title').matchHeight._update();


        // Update cart when CD Delivery is added from checkout.
        $( '.cd-delivery-container .edd-add-to-cart' ).on( 'click', function ( e ) {
            e.preventDefault();
            var $item = $( this );

            var data = {
                action: 'cd_delivery_update_cart',
                id: $item.attr( 'data-id' ),
                price: $item.attr( 'data-price' ),
                nonce: $item.attr( 'data-nonce' ),
                key: $item.attr( 'data-key' )
            };

            $.ajax( {
                type: "POST",
                data: data,
                dataType: "json",
                url: edd_scripts.ajaxurl,
                xhrFields: {
                    withCredentials: true
                },
                complete: function ( response ) {
                    window.location.reload();
                }
            } );
        });

    });

}

// Code that can run as soon as this script is hit in the footer.



// WEBPACK FOOTER //
// ./wp-content/themes/mk2018/static/src/index.js